import { render, staticRenderFns } from "./fccDescricaoDasOpcoes.vue?vue&type=template&id=480b095e"
import script from "./fccDescricaoDasOpcoes.vue?vue&type=script&lang=js"
export * from "./fccDescricaoDasOpcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports